import React, { useEffect, useRef } from 'react';
import { Radio, RadioGroup, FormControlLabel } from '@material-ui/core';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";

// Component Used to Include Radio Buttons
// Component which accepts the below parameters 
// RadioPrefix-- Text to display before Radio Buttons
// Radio1Value,Radio2Value -- Value for RadioButtons
// Radio1Label,Radio2Label -- Label for RadioButtons
// RadioWithStyle -- Boolean Value for Addon Css
// defaultSelected -- Default selected Radio Button

function EirRadioButton(props) {

    const Radio1 = useRef(null);
    const Radio2 = useRef(null);

    useEffect(() => {
        if (props.defaultSelected) {
            if (props.defaultSelected == 'Radio1') {
                console.log("In switch");
                Radio1.current.click();
            }
            else {
                Radio2.current.click();
            }
        }
    }, []);


    const toggleClass = (event) => {
        if (props.RadioWithStyle) {
            var arrow = document.createElement('SPAN');
            arrow.id = 'triangleSpan'
            arrow.classList.add('prepay-arrow-down', 'prepay-arrow-down-tv');
            if (document.getElementById('triangleSpan') != null || document.getElementById('triangleSpan') != undefined)
                document.getElementById('triangleSpan').remove();
            Radio1.current.classList.remove('purple-background');
            Radio2.current.classList.remove('purple-background');
            event.target.parentNode.parentNode.parentNode.classList.add('purple-background');
            event.target.parentNode.appendChild(arrow);
        }
        else {
            Radio1.current.classList.remove('purple-border');
            Radio2.current.classList.remove('purple-border');
            event.target.parentNode.parentNode.parentNode.classList.add('purple-border');

            //** adding tick-icon when option is selected ----start *****/
            Radio1.current.classList.remove('radioBtn-selected');
            Radio2.current.classList.remove('radioBtn-selected');
            event.target.parentNode.parentNode.parentNode.classList.add('radioBtn-selected');

            //** adding tick-icon when option is selected ---end  *****/
        }
        props.handleChange(event);
    }

    return (
        <div>
            <div className={(isMobileOnly) ? '' : 'd-flex justify-content-center align-items-center'}>
                {(props.RadioPrefix) &&
                    <p className={(isMobileOnly) ? 'd-flex flex-column justify-content-center align-items-center text-center ml-3 mr-3 font-weight-bold' : 'mr-4 mt-3 font-weight-bold'}>{props.RadioPrefix}</p>
                }
                <RadioGroup
                    aria-label={props.RadioAriaLabel}
                    name={props.RadioName}
                    className={'radio-group ' + (isMobileOnly) ? 'd-block ml-4' : ''}
                >
                    <FormControlLabel ref={Radio1} className='white-background margin-radio-tv radio-tv' value={props.Radio1Value} control={<Radio color="primary" onClick={toggleClass} />} label={props.Radio1Label} />
                    <FormControlLabel ref={Radio2} className='white-background radio-tv' value={props.Radio2Value} control={<Radio color="primary" onClick={toggleClass} />} label={props.Radio2Label} />
                </RadioGroup>
            </div>
        </div>
    );

}
export default EirRadioButton;
